import { FileUploader } from "devextreme-react";
import React from "react";

const handleBeforeSend = (e) => {
  e.request.withCredentials = true;
};

export default function AuthFileUploader({ onBeforeSend, ...props }) {
  const beforeSend = onBeforeSend
    ? (e) => { handleBeforeSend(e); onBeforeSend(e); }
    : handleBeforeSend;

  return <FileUploader onBeforeSend={beforeSend} {...props} />;
}
